{
	"nm": "Comp 2",
	"ddd": 0,
	"h": 1080,
	"w": 1080,
	"meta": { "g": "LottieFiles AE " },
	"layers": [
		{
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"st": 0,
			"op": 184,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": { "a": 0, "k": [-0.125, -86, 0], "ix": 1 },
				"s": {
					"a": 1,
					"k": [
						{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [46, 46, 100], "t": 0 },
						{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [119, 119, 100], "t": 17 },
						{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [80, 80, 100], "t": 37 },
						{ "s": [100, 100, 100], "t": 58 }
					],
					"ix": 6
				},
				"sk": { "a": 0, "k": 0 },
				"p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"sa": { "a": 0, "k": 0 },
				"o": { "a": 0, "k": 100, "ix": 11 }
			},
			"ef": [],
			"shapes": [
				{
					"ty": "gr",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Group",
					"nm": "Ellipse 1",
					"ix": 1,
					"cix": 2,
					"np": 3,
					"it": [
						{
							"ty": "el",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Shape - Ellipse",
							"nm": "Ellipse Path 1",
							"d": 1,
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"s": { "a": 0, "k": [48, 48], "ix": 2 }
						},
						{
							"ty": "st",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Graphic - Stroke",
							"nm": "Stroke 1",
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 51, "ix": 5 },
							"c": { "a": 0, "k": [0.7412, 0.5294, 0], "ix": 3 }
						},
						{
							"ty": "tr",
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": {
								"a": 1,
								"k": [
									{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0, 0], "t": 16 },
									{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [130.03, 130.03], "t": 24 },
									{ "s": [75.03, 75.03], "t": 31 }
								],
								"ix": 3
							},
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"p": { "a": 0, "k": [-0.125, 148], "ix": 2 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"o": { "a": 0, "k": 100, "ix": 7 }
						}
					]
				},
				{
					"ty": "gr",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Group",
					"nm": "Shape 2",
					"ix": 2,
					"cix": 2,
					"np": 4,
					"it": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Shape - Group",
							"nm": "Path 1",
							"ix": 1,
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": false,
									"i": [
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, -216.625],
										[0, 78.375]
									]
								},
								"ix": 2
							}
						},
						{
							"ty": "tm",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Filter - Trim",
							"nm": "Trim Paths 1",
							"ix": 2,
							"e": {
								"a": 1,
								"k": [
									{ "o": { "x": 0.665, "y": 0.041 }, "i": { "x": 0.421, "y": 1 }, "s": [0], "t": 6 },
									{ "s": [100], "t": 23 }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 0, "ix": 3 },
							"s": { "a": 0, "k": 0, "ix": 1 },
							"m": 1
						},
						{
							"ty": "st",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Graphic - Stroke",
							"nm": "Stroke 1",
							"lc": 2,
							"lj": 1,
							"ml": 4,
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 51, "ix": 5 },
							"c": { "a": 0, "k": [0.7412, 0.5294, 0], "ix": 3 }
						},
						{
							"ty": "tr",
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 84.977], "ix": 3 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"p": { "a": 0, "k": [0, -13], "ix": 2 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"o": { "a": 0, "k": 100, "ix": 7 }
						}
					]
				},
				{
					"ty": "gr",
					"bm": 0,
					"hd": false,
					"mn": "ADBE Vector Group",
					"nm": "Shape 1",
					"ix": 3,
					"cix": 2,
					"np": 5,
					"it": [
						{
							"ty": "sh",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Shape - Group",
							"nm": "Path 1",
							"ix": 1,
							"d": 1,
							"ks": {
								"a": 0,
								"k": {
									"c": true,
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[0, -434],
										[-412, 262],
										[411.75, 262]
									]
								},
								"ix": 2
							}
						},
						{
							"ty": "tm",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Filter - Trim",
							"nm": "Trim Paths 1",
							"ix": 2,
							"e": { "a": 0, "k": 100, "ix": 2 },
							"o": { "a": 0, "k": 0, "ix": 3 },
							"s": { "a": 0, "k": 0, "ix": 1 },
							"m": 1
						},
						{
							"ty": "tm",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Filter - Trim",
							"nm": "Trim Paths 2",
							"ix": 3,
							"e": {
								"a": 1,
								"k": [
									{ "o": { "x": 0.459, "y": 0 }, "i": { "x": 0.576, "y": 1 }, "s": [0], "t": 0 },
									{ "s": [100], "t": 58 }
								],
								"ix": 2
							},
							"o": {
								"a": 1,
								"k": [
									{ "o": { "x": 0.406, "y": 0 }, "i": { "x": 0.601, "y": 1 }, "s": [0], "t": 0 },
									{ "s": [225], "t": 58 }
								],
								"ix": 3
							},
							"s": { "a": 0, "k": 0, "ix": 1 },
							"m": 1
						},
						{
							"ty": "st",
							"bm": 0,
							"hd": false,
							"mn": "ADBE Vector Graphic - Stroke",
							"nm": "Stroke 1",
							"lc": 2,
							"lj": 2,
							"ml": 1,
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 34, "ix": 5 },
							"c": { "a": 0, "k": [0.7412, 0.5294, 0], "ix": 3 }
						},
						{
							"ty": "tr",
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"o": { "a": 0, "k": 100, "ix": 7 }
						}
					]
				}
			],
			"ind": 1
		}
	],
	"v": "4.8.0",
	"fr": 60,
	"op": 184,
	"ip": 0,
	"assets": []
}
